import { send } from '../../../../../../src/network/network';

type RatableItem = {
  object_id: number;
  object_type: string;
};

export interface FoodProfileCategory {
  thumbnail_image: string;
  items: RatableItem[];
}

export interface FoodProfileResponse {
  ratable_objects: Record<string, FoodProfileCategory>;
  ratable_tags: Record<string, number[]>;
}

export async function getApiV2CustomersSelfFoodProfile() {
  return await send<FoodProfileResponse>({
    method: 'GET',
    path: '/api/v2/customers/self/food_profile/',
  });
}
